let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gV84f")).then(() => parcelRequire('7SmYm'));